import { RootState } from '@reducers/index';
import { User } from 'src/types/shared/User';

export const getProfileIsFetching = (state: RootState): boolean => state.profileReducer.isFetching;
export const getProfileFetchError = (state: RootState): string | null =>
    state.profileReducer.fetchError;
export const getProfile = (state: RootState): User | null => state.profileReducer.profile;
export const getProfileIsPosting = (state: RootState): boolean => state.profileReducer.isPosting;
export const getProfileEditPasswordSuccess = (state: RootState): boolean =>
    state.profileReducer.editPasswordSuccess;
export const getProfilePostError = (state: RootState): string | null =>
    state.profileReducer.postError;
